import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserLoginQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type UserLoginQuery = { __typename?: 'Query', userLogins?: Array<{ __typename?: 'UserLogin', userSub: string, name: string, emails: Array<string>, loginNames: Array<string>, isVerified: boolean } | null> | null };

export type AddUserLoginMutationVariables = Types.Exact<{
  loginData: Types.CreateUserLoginInput;
}>;


export type AddUserLoginMutation = { __typename?: 'Mutation', addUserLogin?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type DeleteExtensionUserMutationVariables = Types.Exact<{
  userSub: Types.Scalars['String']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type DeleteExtensionUserMutation = { __typename?: 'Mutation', deleteUserLogin?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type MakeOwnerMutationVariables = Types.Exact<{
  userSub: Types.Scalars['String']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type MakeOwnerMutation = { __typename?: 'Mutation', makeOwner?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type ExtensionOwnerQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionOwnerQuery = { __typename?: 'Query', userOwner?: { __typename?: 'UserOwner', userSub?: string | null } | null };

export type ResendInvitationEmailMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type ResendInvitationEmailMutation = { __typename?: 'Mutation', resendInvitationEmail?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const UserLoginDocument = gql`
    query UserLogin($userId: Int!) {
  userLogins(userId: $userId) {
    userSub
    name
    emails
    loginNames
    isVerified
  }
}
    `;

/**
 * __useUserLoginQuery__
 *
 * To run a query within a React component, call `useUserLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLoginQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserLoginQuery(baseOptions: Apollo.QueryHookOptions<UserLoginQuery, UserLoginQueryVariables> & ({ variables: UserLoginQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLoginQuery, UserLoginQueryVariables>(UserLoginDocument, options);
      }
export function useUserLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLoginQuery, UserLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLoginQuery, UserLoginQueryVariables>(UserLoginDocument, options);
        }
export function useUserLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserLoginQuery, UserLoginQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserLoginQuery, UserLoginQueryVariables>(UserLoginDocument, options);
        }
export type UserLoginQueryHookResult = ReturnType<typeof useUserLoginQuery>;
export type UserLoginLazyQueryHookResult = ReturnType<typeof useUserLoginLazyQuery>;
export type UserLoginSuspenseQueryHookResult = ReturnType<typeof useUserLoginSuspenseQuery>;
export type UserLoginQueryResult = Apollo.QueryResult<UserLoginQuery, UserLoginQueryVariables>;
export const AddUserLoginDocument = gql`
    mutation AddUserLogin($loginData: CreateUserLoginInput!) {
  addUserLogin(loginData: $loginData) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type AddUserLoginMutationFn = Apollo.MutationFunction<AddUserLoginMutation, AddUserLoginMutationVariables>;

/**
 * __useAddUserLoginMutation__
 *
 * To run a mutation, you first call `useAddUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserLoginMutation, { data, loading, error }] = useAddUserLoginMutation({
 *   variables: {
 *      loginData: // value for 'loginData'
 *   },
 * });
 */
export function useAddUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<AddUserLoginMutation, AddUserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserLoginMutation, AddUserLoginMutationVariables>(AddUserLoginDocument, options);
      }
export type AddUserLoginMutationHookResult = ReturnType<typeof useAddUserLoginMutation>;
export type AddUserLoginMutationResult = Apollo.MutationResult<AddUserLoginMutation>;
export type AddUserLoginMutationOptions = Apollo.BaseMutationOptions<AddUserLoginMutation, AddUserLoginMutationVariables>;
export const DeleteExtensionUserDocument = gql`
    mutation DeleteExtensionUser($userSub: String!, $userId: Int!) {
  deleteUserLogin(userSub: $userSub, userId: $userId) {
    location
    context
    type
  }
}
    `;
export type DeleteExtensionUserMutationFn = Apollo.MutationFunction<DeleteExtensionUserMutation, DeleteExtensionUserMutationVariables>;

/**
 * __useDeleteExtensionUserMutation__
 *
 * To run a mutation, you first call `useDeleteExtensionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtensionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtensionUserMutation, { data, loading, error }] = useDeleteExtensionUserMutation({
 *   variables: {
 *      userSub: // value for 'userSub'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteExtensionUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExtensionUserMutation, DeleteExtensionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExtensionUserMutation, DeleteExtensionUserMutationVariables>(DeleteExtensionUserDocument, options);
      }
export type DeleteExtensionUserMutationHookResult = ReturnType<typeof useDeleteExtensionUserMutation>;
export type DeleteExtensionUserMutationResult = Apollo.MutationResult<DeleteExtensionUserMutation>;
export type DeleteExtensionUserMutationOptions = Apollo.BaseMutationOptions<DeleteExtensionUserMutation, DeleteExtensionUserMutationVariables>;
export const MakeOwnerDocument = gql`
    mutation MakeOwner($userSub: String!, $userId: Int!) {
  makeOwner(userSub: $userSub, userId: $userId) {
    location
    context
    type
  }
}
    `;
export type MakeOwnerMutationFn = Apollo.MutationFunction<MakeOwnerMutation, MakeOwnerMutationVariables>;

/**
 * __useMakeOwnerMutation__
 *
 * To run a mutation, you first call `useMakeOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeOwnerMutation, { data, loading, error }] = useMakeOwnerMutation({
 *   variables: {
 *      userSub: // value for 'userSub'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMakeOwnerMutation(baseOptions?: Apollo.MutationHookOptions<MakeOwnerMutation, MakeOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeOwnerMutation, MakeOwnerMutationVariables>(MakeOwnerDocument, options);
      }
export type MakeOwnerMutationHookResult = ReturnType<typeof useMakeOwnerMutation>;
export type MakeOwnerMutationResult = Apollo.MutationResult<MakeOwnerMutation>;
export type MakeOwnerMutationOptions = Apollo.BaseMutationOptions<MakeOwnerMutation, MakeOwnerMutationVariables>;
export const ExtensionOwnerDocument = gql`
    query ExtensionOwner($userId: Int!) {
  userOwner(userId: $userId) {
    userSub
  }
}
    `;

/**
 * __useExtensionOwnerQuery__
 *
 * To run a query within a React component, call `useExtensionOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionOwnerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionOwnerQuery(baseOptions: Apollo.QueryHookOptions<ExtensionOwnerQuery, ExtensionOwnerQueryVariables> & ({ variables: ExtensionOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>(ExtensionOwnerDocument, options);
      }
export function useExtensionOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>(ExtensionOwnerDocument, options);
        }
export function useExtensionOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>(ExtensionOwnerDocument, options);
        }
export type ExtensionOwnerQueryHookResult = ReturnType<typeof useExtensionOwnerQuery>;
export type ExtensionOwnerLazyQueryHookResult = ReturnType<typeof useExtensionOwnerLazyQuery>;
export type ExtensionOwnerSuspenseQueryHookResult = ReturnType<typeof useExtensionOwnerSuspenseQuery>;
export type ExtensionOwnerQueryResult = Apollo.QueryResult<ExtensionOwnerQuery, ExtensionOwnerQueryVariables>;
export const ResendInvitationEmailDocument = gql`
    mutation ResendInvitationEmail($userId: Int!, $email: String!) {
  resendInvitationEmail(userId: $userId, email: $email) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type ResendInvitationEmailMutationFn = Apollo.MutationFunction<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;

/**
 * __useResendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailMutation, { data, loading, error }] = useResendInvitationEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>(ResendInvitationEmailDocument, options);
      }
export type ResendInvitationEmailMutationHookResult = ReturnType<typeof useResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationResult = Apollo.MutationResult<ResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;